import { NegativeClientStock } from '@Balance/Hooks/useNegativeStocks/useNegativeStocks.types'
import { StockByClient } from '@Balance/Summary/Context/SummaryContext.types'
import { Stock } from '@Core/Entities/Stock'

export const exportStockByClientData = (
    stocksByClient: StockByClient
): Stock[] => {
    if (!stocksByClient) return []
    const stockArray = Object.values(stocksByClient)
        .filter((clientStocks) => clientStocks?.length > 0)
        .flatMap((clientStocks) =>
            clientStocks.map((stock) => ({
                ...stock,
                client: stock.client[0],
                lastInput: stock.product[0].lastInput,
                lastOut: stock.product[0].lastOut,
            }))
        )
    // @ts-ignore
    return stockArray
}

export const exportNegativeStockByClientData = (
    stocksByClient: NegativeClientStock[]
): any[] => {
    if (!stocksByClient) return []

    const stockArray: any[] = []

    stocksByClient.forEach((negativeStock) => {
        const client = negativeStock.client[0]

        negativeStock.product.forEach((product) => {
            stockArray.push({
                _id: negativeStock._id,
                client: client,
                product: [{ name: [product.name] }],
                amount: product.amount,
            })
        })
    })

    return stockArray
}

// Dicionários para exportação de estoque negativo
export const exportNegativeStockDictionary = (item: any) => {
    const dict: Record<string, string> = {
        _id: 'ID',
        client: 'Cliente',
        product: 'Produto',
        amount: 'Saldo',
    }
    return dict[item] || item
}

export const exportNegativeStockValueDictionary = (key: any, item: any) => {
    const dict: Record<string, any> = {
        _id: { value: item, type: 'string' },
        client: { value: item?.corporateName, type: 'string' },
        product: { value: item[0]?.name, type: 'string' },
        amount: { value: item, type: 'number' },
    }
    return dict[key] || { value: item, type: 'string' }
}
